module.exports = __webpack_public_path__ + "frontend-assets/img/back_button.0b041916.png";